import { render, staticRenderFns } from "./PopupSpendBudget.vue?vue&type=template&id=6fa7f3c2&"
import script from "./PopupSpendBudget.vue?vue&type=script&lang=js&"
export * from "./PopupSpendBudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports